import axios from 'axios'

const config = {
  baseURL:
    window.VW_BASE_URL || process.env.VW_BASE_URL || window.location.origin
}

/**
 * If VWID is integrated into your app then pass a user object (see `getToken()`)
 * and that will crate the Authorization header
 * To test a 401 error change:
 */
const getApiInstance = () =>
  axios.create({
    ...config,
    headers: {
      'content-type': 'application/x-www-form-urlencoded;charset=utf-8'
    },
    // Allow 400 errors to pass through as they contain our server-side error messages
    validateStatus: status => (status >= 200 && status < 300) || status === 400
  }) || axios.create(config)

/**
 * submitForm
 * Submit the form
 *
 * @param {string} endpoint - the basename of API endpoint e.g.
 * @param {object} body - JSON parameters to send to endpoint
 */
export const submitForm = (endpoint, params) => {
  const api = getApiInstance()

  return api
    .post(endpoint, params)
    .then(response => response)
    .catch(error => {
      throw new Error(error)
    })
}
